"use client";

import { motion } from "motion/react";
import {
  slideUpVariants,
  fadeInVariants,
  staggerContainerVariants,
} from "@/lib/animations";
import Image from "next/image";
import { beyondItems } from "../data";
import { Flash } from "@/components/icons/Flash";
import { BeyondCard } from "./BeyondCard";

export function Beyond() {
  return (
    <section className="px-5 py-10 md:px-6 md:py-14 lg:px-10 lg:py-16 2xl:py-20">
      <div className="mx-auto mb-10 max-w-8xl md:mb-12 lg:mb-16 2xl:mb-20">
        <motion.h2
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={slideUpVariants}
          className="max-w-md text-2xl font-medium tracking-copy sm:text-3xl md:text-4xl lg:max-w-xl lg:text-5xl lg:leading-[1.18]"
        >
          Beyond just a device, We&apos;re invested in your progress
        </motion.h2>

        <motion.div
          className="mt-10 space-y-2"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
          variants={staggerContainerVariants}
        >
          <motion.div
            className="flex flex-col gap-2 sm:flex-row"
            variants={slideUpVariants}
          >
            <BeyondCard
              title={beyondItems[0].title}
              description={beyondItems[0].description}
              bg="beyond-1"
              width="large"
            />
            <BeyondCard
              title={beyondItems[1].title}
              description={beyondItems[1].description}
              bg="beyond-2"
              width="small"
            />
          </motion.div>

          <motion.div
            className="flex flex-col gap-2 sm:flex-row"
            variants={slideUpVariants}
          >
            <BeyondCard
              title={beyondItems[2].title}
              description={beyondItems[2].description}
              bg="beyond-3"
              width="small"
            />
            <BeyondCard
              title={beyondItems[3].title}
              description={beyondItems[3].description}
              bg="beyond-4"
              width="large"
            />
          </motion.div>

          <motion.div
            className="flex flex-col gap-2 sm:flex-row"
            variants={slideUpVariants}
          >
            <BeyondCard
              title={beyondItems[4].title}
              description={beyondItems[4].description}
              bg="beyond-5"
              width="medium"
            />

            <motion.div
              className="relative h-60 overflow-hidden rounded-3xl bg-green-700 sm:w-[45%] lg:h-[354px]"
              variants={fadeInVariants}
            >
              <div className="relative z-10 flex h-full justify-center gap-12 p-5 !pb-0 sm:gap-5 md:gap-8 lg:p-6 xl:gap-12">
                <div className="flex flex-col items-center justify-center text-center lg:w-[20%] xl:w-auto xl:pb-14">
                  <Flash />
                  <p className="text-black-400 mt-2.5 text-xl font-medium sm:text-lg md:text-xl lg:text-2xl xl:max-w-40 xl:text-4xl">
                    Own and Pay Easy
                  </p>
                </div>

                <div className="flex justify-end">
                  <Image
                    src="/assets/images/app-shot-1.webp"
                    alt="customer app shot"
                    width={200}
                    height={200}
                    className="w-full"
                  />
                </div>
              </div>

              <div className="beyond-bg beyond-bg--1" />
              <div className="beyond-bg beyond-bg--2" />
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
